import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { StarIcon } from 'lucide-react';
interface Testimonial {
  id: string;
  initial: string;
  name: string;
  age: string;
  text: string;
}
const TESTIMONIALS: Testimonial[] = [{
  id: 't1',
  initial: 'M',
  name: 'María Elena R.',
  age: '54 años',
  text: 'Llevaba más de un año sin dormir bien y pensé que ya era normal a mi edad. Con la checklist nocturna del bono 2 empecé a notar la diferencia desde la primera semana. Ya no me despierto a las 3 AM como antes. Mi familia también lo notó.'
}, {
  id: 't2',
  initial: 'P',
  name: 'Patricia G.',
  age: '58 años',
  text: 'Los bochornos me tenían desesperada. No podía ir a ningún lado tranquila. Lo que más me ayudó fue el kit de emergencia, lo tengo en el celular y lo uso cuando los siento venir. El protocolo principal me ayudó a entender por qué me pasaba y eso solo ya valió la pena.'
}, {
  id: 't3',
  initial: 'R',
  name: 'Rosa María T.',
  age: '52 años',
  text: 'Había probado de todo y nada me funcionaba porque nadie me explicaba qué le estaba pasando a mi metabolismo. Los menús de la semana me salvaron porque no tengo tiempo de andar pensando qué cocinar. Ya bajé dos tallas en seis semanas y duermo mucho mejor.'
}];
export function TestimonialsSection() {
  return <section className="py-12 md:py-16 bg-[#f5ede0]" data-id="element-219">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-220">
        <div className="text-center mb-12" data-id="element-221">
          <h2 className="font-serif text-3xl md:text-4xl text-[#2d2d2d] mb-4" data-id="element-222">
            Lo que dicen las mujeres que ya comenzaron su cambio
          </h2>
          <p className="text-lg md:text-xl text-[#b8954d] font-medium" data-id="element-223">
            Resultados reales de mujeres de 50 y más
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-224">
          {TESTIMONIALS.map((testimonial, idx) => <TestimonialCard key={testimonial.id} testimonial={testimonial} index={idx} data-id="element-225" />)}
        </div>
      </div>
    </section>;
}
function TestimonialCard({
  testimonial,
  index
}: {
  testimonial: Testimonial;
  index: number;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 30
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.6,
    delay: index * 0.1
  }} className="bg-white rounded-2xl shadow-md p-8 flex flex-col items-center text-center relative" data-id="element-226">
      <div className="w-14 h-14 rounded-full bg-[#5d6e4f] text-white flex items-center justify-center font-serif text-xl mb-4 shadow-sm" data-id="element-227">
        {testimonial.initial}
      </div>

      <div className="mb-4" data-id="element-228">
        <p className="font-bold text-[#2d2d2d]" data-id="element-229">{testimonial.name}</p>
        <p className="text-sm text-[#7a8a6b]" data-id="element-230">{testimonial.age}</p>
      </div>

      <div className="flex gap-1 mb-6" data-id="element-231">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#c9a961] fill-current" data-id="element-232" />)}
      </div>

      <p className="text-[#2d2d2d] italic leading-relaxed mb-6 flex-grow" data-id="element-233">
        "{testimonial.text}"
      </p>

      <div className="text-[#c9a961] opacity-50" data-id="element-234">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-235">
          <path d="M12 2C12 2 12 10 20 12C12 14 12 22 12 22C12 22 12 14 4 12C12 10 12 2 12 2Z" fill="currentColor" data-id="element-236" />
        </svg>
      </div>
    </motion.div>;
}